import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import PackagingMarketing from "legacy/PackagingMarketing"
import PropTypes from "prop-types"
import React from "react"

class SaleEmptyView extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.handleCreateNew = this.handleCreateNew.bind(this)
  }

  handleCreateNew() {
    if (this.props.createUrl) {
      window.location.href = this.props.createUrl
    } else if (this.props.setView) {
      this.props.setView("new")
    }
  }

  render() {
    // Note: $context is loaded globally
    if (
      !(
        $context.packagingTransientReservationsEnabled ||
        $context.packagingPosEnabled
      )
    ) {
      return (
        <PackagingMarketing
          header="Point of Sale"
          featureKey="point_of_sale"
          imageUrl="https://images.unsplash.com/photo-1626178890643-3769ecb58d77?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3732&q=80"
          btnUrl={$context.featureRequestPath}
          paragraph="You've already made online inquiries and slip reservations easier, with Dockwa POS
                you can extend that simplicity to onsite transactions and make those charges more trackable.
                Use the charges screen to charge boaters for purchases at your shipstore, restaurant, fuel dock,
                or service yard. Charge on-site or attach those charges to contracts in advance and see a clear
                report of all revenue brought in for your accounting needs."
        />
      )
    }
    return (
      <div className="card mt-3">
        <h2 className="mt-0 text-xl">
          Picture all your sales neatly lined up here (just like stacks of
          money).
        </h2>
        {this.props.canCreateNewSales && (
          <LegacyButton type="primary" onClick={this.handleCreateNew}>
            Create New Sale
          </LegacyButton>
        )}
      </div>
    )
  }
}

SaleEmptyView.propTypes = {
  createUrl: PropTypes.string,
  setView: PropTypes.func,
  canCreateNewSales: PropTypes.bool,
}

export default SaleEmptyView
